var _style, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSymbolPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 425.2 425.2",
    style: {
      enableBackground: "new 0 0 425.2 425.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#9835D1;}\n\t.st1{fill:none;stroke:#9835D1;stroke-width:4;stroke-miterlimit:10;}\n\t.st2{fill:#9835D1;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M175.58,41.17c50.83-0.41,42.32,49.16,60.63,80.54c6.8,11.65,14.69,23.8,24.94,32.03 c13.13,10.54,25.81,18.01,29.97,37.75c0.98,4.64,0.52,11.02-0.46,15.1c-4.88,20.44-14.54,22-24.94,35.23 c-16.51,21.01-28.31,47.8-37.3,76.19c-10.55,33.35-8.86,61.86-47.82,65.89c-6.06,0.63-14.07-1.15-18.53-2.97 c-14.99-6.12-32.75-23.67-27.46-47.82c4.94-22.52,24.39-32.66,36.38-48.51c16.33-21.6,24.08-43.4,30.2-75.73 c6.63-34.98-12.56-52.14-26.77-69.78c-3.62-4.5-8.28-9.03-12.81-12.59c-6.94-5.44-15.15-10.01-20.36-17.16 c-2.62-3.59-4.77-8.13-6.18-12.81C128.02,73,146.41,51.1,160.94,44.82C165.36,42.92,168.74,41.5,175.58,41.17"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 256.14,
    cy: 352.37,
    r: 14.97
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M249.11,360.54v-16.35h6.95c1.75,0,3.02,0.15,3.81,0.44s1.43,0.82,1.9,1.57c0.48,0.75,0.71,1.61,0.71,2.58 c0,1.23-0.36,2.24-1.08,3.04c-0.72,0.8-1.8,1.3-3.23,1.51c0.71,0.42,1.3,0.87,1.77,1.37c0.46,0.5,1.09,1.38,1.88,2.65l2,3.19 h-3.95l-2.39-3.56c-0.85-1.27-1.43-2.07-1.74-2.4c-0.31-0.33-0.64-0.56-0.99-0.68c-0.35-0.12-0.9-0.18-1.66-0.18h-0.67v6.83 H249.11z M252.41,351.11h2.44c1.58,0,2.57-0.07,2.97-0.2s0.7-0.36,0.93-0.69c0.22-0.33,0.33-0.74,0.33-1.23 c0-0.55-0.15-0.99-0.44-1.33s-0.71-0.55-1.24-0.64c-0.27-0.04-1.07-0.06-2.41-0.06h-2.58V351.11z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolPurple);
export default __webpack_public_path__ + "static/media/symbol-purple.6fdc8c5fd5dad975adb533539e23753c.svg";
export { ForwardRef as ReactComponent };